/** Open Source Project (MIT)
 * https://github.com/smirzaei/currency-formatter - has most that we need and can do custom formatting as well
 */
import { format, unformat, findCurrency } from 'currency-formatter'

/**
 * @param {Object} priceDetails
 * @param {string} priceDetails.price - a full price string ex. $345.67
 * @param {string} priceDetails.dollar - just the dollar ex. $345
 * @param {string} priceDetails.cents - just the cents ex. 67
 * @param {string} priceDetails.currencyCode - 3 digit currency code ex. USD
 * @param {bool} [priceDetails.isRounded] - should the return be rounded
 *
 * @returns {Object} - priceObj
 * @returns {string} - priceObj.symbol - ex. '$'
 * @returns {number} - priceObj.dollar - ex. 345
 * @returns {number} - priceObj.cents - ex. 67
 * @returns {string} - priceObj.decimalSeparator - ex. '.'
 */
export default function priceFormatter({ price, dollar, cents, currencyCode = 'USD', isRounded = false }) {
  const internalPrice = price || dollar
  const { symbol, decimalSeparator, thousandsSeparator, decimalDigits, code } =
    findCurrency(currencyCode) || findCurrency('USD')

  const rawDollars = unformat(internalPrice, { code })
  const rawCents = decimalDigits && !price ? parseInt(cents, 10) / 10 ** decimalDigits : 0
  const rawPrice = rawDollars + rawCents
  const formatOptions = {
    code,
    // some currencies have a precision of more than or less than 2
    // also when the precision is '0' it will automatically round the number
    precision: isRounded ? 0 : decimalDigits,
    symbol: '',
  }

  const displayPrice = format(rawPrice, formatOptions).split(decimalSeparator)

  return {
    symbol,
    decimalSeparator,
    dollar: displayPrice[0],
    cents: displayPrice[1] || null,
    thousandsSeparator,
    currencyCode: code,
  }
}
